<script>
    let year = new Date().getFullYear();
</script>
  
<style>
footer{
    display:flex;
    align-items: center;
    justify-content: center;
    color: whitesmoke;
    margin: 10px;
}
</style>
<footer><p>&copy; {year} Dark River Systems (a Sapper Labs Group company) </p></footer>
  